import {createSlice} from '@reduxjs/toolkit';

import type {RootState} from './store/ChatAppStore';

interface DisplayChatAction {
  type: 'displayChat';
  payload: {
    url: string;
  };
}

interface ChatState {
  hiddenChats: Array<string>;
}

export const chatSlice = createSlice({
  name: 'aichat',
  initialState: {hiddenChats: []} as ChatState,
  reducers: {
    toggleChat: (state, action: DisplayChatAction) => {
      const url = action.payload.url;
      const chats = state.hiddenChats;

      state.hiddenChats = chats.includes(url)
        ? chats.filter((item) => item != url)
        : [...chats, action.payload.url];
    },
  },
});

export const selectIsHidingChat = (state: RootState, url: string) => {
  return state.aichat.hiddenChats.includes(url);
};

export const {toggleChat} = chatSlice.actions;
